var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70.32 79.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:#eacc1d;stroke-miterlimit:10;stroke-width:2px;}.cls-1{stroke:url(#radial-gradient);}.cls-2{stroke:url(#radial-gradient-2);}.cls-3{stroke:url(#radial-gradient-3);}.cls-4{stroke:url(#radial-gradient-4);}.cls-5{fill:#ec008c;}.cls-6{fill:#ca1586;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 35.23,
    cy: 29.99,
    r: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcef42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fce536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fdd423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fdca18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fdc714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f29040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ed693c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e74039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 16.63,
    cy: 61.96,
    r: 17.19,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 25.83,
    cy: 45.93,
    r: 30.05,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 45.8,
    cy: 34.45,
    r: 29.9,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.79 28.31 50.67 46.06 50.67 31.27 19.79 13.9 19.79 28.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1 60.35 32.27 77.97 32.27 63.56 1 45.94 1 60.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13.74 31.64 13.74 13.9 1 21.1 1 38.86 1.03 38.88 38.06 59.83 38.06 59.86 38.31 77.97 50.67 70.9 50.67 53.17 50.67 53.14 13.74 31.65 13.74 31.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "35.23 1.16 23.26 8.11 56.97 28.05 56.97 28.07 56.97 67.17 69.32 60.09 69.32 21.29 69.32 21.23 35.23 1.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "19.79 13.9 19.79 28.31 50.67 46.06 50.67 31.27 19.79 13.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1 45.94 1 60.35 32.27 77.97 32.27 63.56 1 45.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "13.74 13.9 1 21.1 1 38.86 1.03 38.88 13.74 31.64 13.74 13.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "38.06 59.86 38.31 77.97 50.67 70.9 50.67 53.17 38.06 59.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "50.67 53.14 13.74 31.65 13.74 31.64 1.03 38.88 38.06 59.83 38.06 59.86 50.67 53.17 50.67 53.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "69.32 21.23 35.23 1.16 23.26 8.11 56.97 28.05 56.97 28.07 69.32 21.29 69.32 21.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "56.97 28.07 56.97 67.17 69.32 60.09 69.32 21.29 56.97 28.07"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEq);
export default __webpack_public_path__ + "static/media/EQ.42b921d8c849e4a40a49a19b64943c80.svg";
export { ForwardRef as ReactComponent };